import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStudy = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_5050_615)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M50 0C40.111 0 30.444 2.93245 22.2215 8.42652C13.9991 13.9206 7.59043 21.7295 3.80605 30.8658C0.0216644 40.0021 -0.968503 50.0555 0.960758 59.7545C2.89002 69.4536 7.65206 78.3627 14.6447 85.3553C21.6373 92.348 30.5465 97.11 40.2455 99.0393C49.9446 100.969 59.9979 99.9783 69.1342 96.194C78.2705 92.4096 86.0794 86.001 91.5735 77.7785C97.0676 69.5561 100 59.8891 100 50C99.9846 36.7439 94.7118 24.0352 85.3383 14.6617C75.9648 5.28824 63.2561 0.0154384 50 0Z",
				fill: "#006ADC"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.5 47.2991L26.5 48.3973V60.3349C26.5 61.1633 25.8284 61.8349 25 61.8349C24.1716 61.8349 23.5 61.1633 23.5 60.3349V47.2991Z",
			fill: "#FBFBFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.9793 49.671L49.3125 56.7484C49.7564 56.9109 50.2436 56.9109 50.6875 56.7484L70.021 49.6709V62.777C70.0243 63.5704 69.7864 64.3465 69.3381 65.0048C68.8897 65.6631 68.2516 66.1732 67.5063 66.469L51.4897 72.7981C50.5328 73.1724 49.4675 73.1724 48.5106 72.7981L32.4939 66.469C31.7487 66.1732 31.1105 65.6631 30.6622 65.0048C30.2138 64.3465 29.9759 63.5704 29.9793 62.777V49.671Z",
			fill: "#FBFBFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.7535 26.2052C50.2704 26.0087 49.7296 26.0087 49.2465 26.2052L18.7869 38.5938C17.0894 39.2842 17.137 41.704 18.8602 42.3272L49.3198 53.3428C49.7594 53.5018 50.2407 53.5018 50.6802 53.3428L81.1398 42.3272C82.8631 41.704 82.9106 39.2842 81.2132 38.5938L50.7535 26.2052Z",
			fill: "#FBFBFB"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5050_615",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgStudy);
export default ForwardRef;
